import { findModuleExport } from '../webpack';
/** @component React Components */
export const ControlsList = findModuleExport((e) => e?.toString && e.toString().includes('().ControlsListChild') && e.toString().includes('().ControlsListOuterPanel'));
